import React from 'react';
import { 
  LuPhone, 
  LuSchool, 
  LuGraduationCap, 
  LuHospital, 
  LuTent, 
  LuHeart,
  LuUsers,
  LuPlus,
  LuMinus,
  LuMapPin,
  LuBuilding2,
  LuShield,
  LuSparkles,
  LuCompass
} from 'react-icons/lu';
import { GiChurch, GiBookmarklet, GiCrossedChains } from 'react-icons/gi';
import { FaCross } from 'react-icons/fa';
import aerialHero from '../../assets/BannerEdu.png';
import cmsImg from '../../assets/cms.png';

export default function OurInstitutions({ activeSection = 'institutions', onSelectSection = () => {} }) {

  const featuredInstitutions = [
    {
      id: 1,
      name: "CSI K.H. High School",
      type: "School",
      badgeText: "School",
      location: "Kozhikode",
      desc: "Nurturing young minds with values and excellence.",
      role: "Principal",
      leader: "Mr. Babu Mathew",
      est: "Est. 1902",
      img: "https://images.unsplash.com/photo-1580582932707-520aed937b7b?auto=format&fit=crop&q=80&w=600",
      route: "aided-high-schools"
    },
    {
      id: 2,
      name: "CMS College Kottayam",
      type: "College",
      badgeText: "College",
      location: "Kottayam",
      desc: "Empowering students through quality higher education.",
      role: "Principal",
      leader: "Dr. Thomas Varghese",
      est: "Est. 1817",
      img: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?auto=format&fit=crop&q=80&w=600",
      route: "colleges"
    },
    {
      id: 3,
      name: "CSI Mission Hospital",
      type: "Hospital",
      badgeText: "Hospital",
      location: "Calicut",
      desc: "Compassionate care with modern medical excellence.",
      role: "Medical Director",
      leader: "Dr. John Mathew",
      est: "Est. 1892",
      img: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&q=80&w=600",
      route: "hospitals"
    },
    {
      id: 4,
      name: "Santi Bhavan Retreat Centre",
      type: "Retreat",
      badgeText: "Retreat Centre",
      location: "Wayanad",
      desc: "A place of prayer, peace and spiritual renewal.",
      role: "Director",
      leader: "Rev. J. Mathew",
      est: "Est. 1985",
      img: "https://images.unsplash.com/photo-1544735716-392fe2489ffa?auto=format&fit=crop&q=80&w=600",
      route: "retreat"
    },
    {
      id: 5,
      name: "Diocesan Book Shop",
      type: "Book Shop",
      badgeText: "Book Shop",
      location: "Calicut",
      desc: "Spreading God's word through books and resources.",
      role: "Manager",
      leader: "Mr. Shibu Samuel",
      est: "Est. 1978",
      img: "https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?auto=format&fit=crop&q=80&w=600",
      route: "bookshop"
    },
    {
      id: 6,
      name: "Diocesan Social Board",
      type: "Social Board",
      badgeText: "Social Service",
      location: "Calicut",
      desc: "Serving the community through various social missions.",
      role: "Secretary",
      leader: "Mrs. Lucy Mathew",
      est: "Est. 1959",
      img: "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?auto=format&fit=crop&q=80&w=600",
      route: "socialboard"
    }
  ];

  const categoryCards = [
    {
      title: "Schools",
      count: "72 Institutions",
      desc: "Inspiring minds for a better tomorrow.",
      icon: LuSchool,
      route: "schools",
      img: "https://images.unsplash.com/photo-1509062522246-3755977927d7?auto=format&fit=crop&q=80&w=600"
    },
    {
      title: "Colleges",
      count: "3 Institutions",
      desc: "Excellence in higher education.",
      icon: LuGraduationCap,
      route: "colleges",
      img: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?auto=format&fit=crop&q=80&w=600"
    },
    {
      title: "Hospitals",
      count: "1 Institutions",
      desc: "Healing hands, caring hearts.",
      icon: LuHospital,
      route: "hospitals",
      img: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&q=80&w=600"
    },
    {
      title: "Retreat Centres",
      count: "2 Institutions",
      desc: "Find peace and spiritual renewal.",
      icon: LuTent,
      route: "retreat",
      img: "https://images.unsplash.com/photo-1544735716-392fe2489ffa?auto=format&fit=crop&q=80&w=600"
    },
    {
      title: "Book Shop",
      count: "1 Institution",
      desc: "Books that inspire faith and life.",
      icon: GiBookmarklet,
      route: "bookshop",
      img: "https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?auto=format&fit=crop&q=80&w=600"
    },
    {
      title: "Child Care Projects",
      count: "5 Projects",
      desc: "Building a brighter future for children.",
      icon: LuHeart,
      route: "childcare",
      img: "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?auto=format&fit=crop&q=80&w=600"
    },
    {
      title: "Social Board",
      count: "2 Institutions",
      desc: "Empowering communities, transforming lives.",
      icon: LuUsers,
      route: "socialboard",
      img: "https://images.unsplash.com/photo-1511632765486-a01980e01a18?auto=format&fit=crop&q=80&w=600"
    }
  ];

  return (
    <div className="text-[#2D2420] font-sans pb-20 selection:bg-[#7B1E3A]/20 selection:text-[#7B1E3A]">
      
      {/* ── 1. Hero Header Banner ── */}
      <section className="relative w-full  overflow-hidden min-h-[380px] sm:min-h-[420px] lg:min-h-[440px] flex items-center">
        <div className="absolute inset-0 z-0">
          <img 
            src={aerialHero} 
            alt="CSI Institutions Campus Aerial View" 
            className="w-full h-full object-cover object-center filter brightness-[0.75] contrast-[1.08]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#140e1b]/90 via-[#140e1b]/40 to-black/30"></div>
          <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-transparent to-black/40"></div>
        </div>

        <div className="relative z-10 max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 w-full pt-28 sm:pt-32 pb-12 flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8">
          
          {/* Left Title & Breadcrumb */}
          <div className="max-w-2xl text-left">
            <h1 className="font-serif font-bold text-white text-[38px] sm:text-[48px] lg:text-[56px] tracking-[0.04em] uppercase leading-[1.05] drop-shadow-md">
              INSTITUTIONS
            </h1>
            <p className="text-[#E8B86D] text-[15px] sm:text-[17px] font-medium tracking-wide mt-2.5 drop-shadow-sm">
              Serving Society Through Faith, Education and Compassion
            </p>
            <div className="flex items-center gap-2 text-xs text-white/80 font-medium mt-4">
              <span onClick={() => onSelectSection('home')} className="hover:text-white cursor-pointer transition-colors">Home</span>
              <span className="text-[#E8B86D] font-bold">›</span>
              <span className="text-white">Institutions</span>
            </div>
          </div>

          {/* Right Floating Stats Cards */}
          <div className="grid grid-cols-3 gap-3 sm:gap-4 w-full sm:w-auto">
            <div className="bg-[#7B1E3A]/90 hover:bg-[#7B1E3A] backdrop-blur-md text-white rounded-2xl p-3.5 sm:p-4 text-center border border-white/15 shadow-[0_8px_25px_rgba(0,0,0,0.3)] transition-all flex flex-col items-center justify-center min-w-[100px] sm:min-w-[125px]">
              <div className="w-8 h-8 rounded-full bg-white/15 flex items-center justify-center mb-1.5 border border-white/20">
                <LuBuilding2 className="w-4 h-4 text-[#E8B86D]" />
              </div>
              <span className="font-serif font-bold text-[20px] sm:text-[24px] leading-tight">120+</span>
              <span className="text-[10.5px] sm:text-[11.5px] text-white/80 tracking-wide font-sans">Institutions</span>
            </div>

            <div className="bg-[#7B1E3A]/90 hover:bg-[#7B1E3A] backdrop-blur-md text-white rounded-2xl p-3.5 sm:p-4 text-center border border-white/15 shadow-[0_8px_25px_rgba(0,0,0,0.3)] transition-all flex flex-col items-center justify-center min-w-[100px] sm:min-w-[125px]">
              <div className="w-8 h-8 rounded-full bg-white/15 flex items-center justify-center mb-1.5 border border-white/20">
                <LuCompass className="w-4 h-4 text-[#E8B86D]" />
              </div>
              <span className="font-serif font-bold text-[20px] sm:text-[24px] leading-tight">175+</span>
              <span className="text-[10.5px] sm:text-[11.5px] text-white/80 tracking-wide font-sans">Years of Service</span>
            </div>

            <div className="bg-[#7B1E3A]/90 hover:bg-[#7B1E3A] backdrop-blur-md text-white rounded-2xl p-3.5 sm:p-4 text-center border border-white/15 shadow-[0_8px_25px_rgba(0,0,0,0.3)] transition-all flex flex-col items-center justify-center min-w-[100px] sm:min-w-[125px]">
              <div className="w-8 h-8 rounded-full bg-white/15 flex items-center justify-center mb-1.5 border border-white/20">
                <LuUsers className="w-4 h-4 text-[#E8B86D]" />
              </div>
              <span className="font-serif font-bold text-[20px] sm:text-[24px] leading-tight">4.5M+</span>
              <span className="text-[10.5px] sm:text-[11.5px] text-white/80 tracking-wide font-sans">Community Members</span>
            </div>
          </div>

        </div>
      </section>

      {/* Main Container */}
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 mt-12 space-y-14">
        
        {/* ── 2. Top Intro Section (Our Institutions + Photo Collage + Stats List) ── */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
          
          {/* Left Column: Intro, Mission & Vision (4 cols) */}
          <div className="lg:col-span-4 flex flex-col justify-between space-y-6">
            <div>
              <h2 className="font-serif font-bold text-[#7B1E3A] text-[28px] sm:text-[32px] leading-tight mb-4">
                Our Institutions
              </h2>
              <p className="text-[13.5px] sm:text-[14px] text-[#5A4F4A] leading-relaxed font-sans">
                The CSI Diocese of Malabar is committed to holistic development of communities through a wide network of educational, medical, spiritual and social service institutions. Our institutions reflect our faith in action and our dedication to excellence and compassion.
              </p>
            </div>

            {/* Mission Box */}
            <div className="bg-white rounded-2xl p-4 sm:p-5 border border-[#ECE5E0] shadow-2xs flex items-start gap-4">
              <div className="w-10 h-10 rounded-full bg-[#FAF0F2] text-[#7B1E3A] flex items-center justify-center shrink-0 border border-[#F2D5DC]">
                <LuHeart className="w-5 h-5" />
              </div>
              <div>
                <h4 className="font-serif font-bold text-[#7B1E3A] text-[15px] mb-1">Mission</h4>
                <p className="text-[12.5px] text-[#6A5F5A] leading-relaxed">
                  To serve with compassion and dedication, uplifting lives through quality services rooted in Christian values.
                </p>
              </div>
            </div>

            {/* Vision Box */}
            <div className="bg-white rounded-2xl p-4 sm:p-5 border border-[#ECE5E0] shadow-2xs flex items-start gap-4">
              <div className="w-10 h-10 rounded-full bg-[#FAF0F2] text-[#7B1E3A] flex items-center justify-center shrink-0 border border-[#F2D5DC]">
                <LuSparkles className="w-5 h-5" />
              </div>
              <div>
                <h4 className="font-serif font-bold text-[#7B1E3A] text-[15px] mb-1">Vision</h4>
                <p className="text-[12.5px] text-[#6A5F5A] leading-relaxed">
                  A transformed society where every individual experiences God's love through our institutions.
                </p>
              </div>
            </div>
          </div>

          {/* Center Column: Photo Collage Grid (5 cols) */}
          <div className="lg:col-span-5 grid grid-cols-3 gap-3 h-full">
            {/* Top Row: Left wide, Right tall */}
            <div className="col-span-2 h-40 rounded-2xl overflow-hidden shadow-xs border border-gray-100 group">
              <img 
                src="https://images.unsplash.com/photo-1541339907198-e08756dedf3f?auto=format&fit=crop&q=80&w=600" 
                alt="Historic College Heritage Building" 
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="col-span-1 h-40 rounded-2xl overflow-hidden shadow-xs border border-gray-100 group">
              <img 
                src="https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&q=80&w=600" 
                alt="Hospital Staff and Faculty" 
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>

            {/* Middle Row */}
            <div className="col-span-1 h-32 rounded-2xl overflow-hidden shadow-xs border border-gray-100 group">
              <img 
                src="https://images.unsplash.com/photo-1580582932707-520aed937b7b?auto=format&fit=crop&q=80&w=600" 
                alt="Mission School Campus" 
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="col-span-1 h-32 rounded-2xl overflow-hidden shadow-xs border border-gray-100 group">
              <img 
                src="https://images.unsplash.com/photo-1544735716-392fe2489ffa?auto=format&fit=crop&q=80&w=600" 
                alt="Sanctuary Chapel" 
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="col-span-1 h-32 rounded-2xl overflow-hidden shadow-xs border border-gray-100 group">
              <img 
                src="https://images.unsplash.com/photo-1511632765486-a01980e01a18?auto=format&fit=crop&q=80&w=600" 
                alt="Convention Gathering" 
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>

            {/* Bottom Row */}
            <div className="col-span-1 h-32 rounded-2xl overflow-hidden shadow-xs border border-gray-100 group">
              <img 
                src="https://images.unsplash.com/photo-1509062522246-3755977927d7?auto=format&fit=crop&q=80&w=600" 
                alt="Prayer Pavilion" 
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="col-span-2 h-32 rounded-2xl overflow-hidden shadow-xs border border-gray-100 group">
              <img 
                src={cmsImg}
                alt="CSI Educational Institution" 
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
          </div>

          {/* Right Column: Diocesan Key Stats Card (3 cols) */}
          <div className="lg:col-span-3 bg-white rounded-2xl p-6 border border-[#ECE5E0] shadow-2xs flex flex-col justify-between space-y-4">
            {[
              { icon: LuCompass, value: "2", label: "States", color: "text-[#D4A64A] bg-[#FAF4ED]" },
              { icon: LuMapPin, value: "5", label: "Districts", color: "text-[#3B82F6] bg-[#EFF6FF]" },
              { icon: GiChurch, value: "26+", label: "Dioceses", color: "text-[#7B1E3A] bg-[#FAF0F2]" },
              { icon: LuGraduationCap, value: "49", label: "Presbyters", color: "text-[#D4A64A] bg-[#FAF4ED]" },
              { icon: LuUsers, value: "27", label: "Workers", color: "text-[#F97316] bg-[#FFF7ED]" },
              { icon: LuHeart, value: "4.5M+", label: "Members", color: "text-[#D4A64A] bg-[#FAF4ED]" }
            ].map((stat, idx) => (
              <div key={idx} className="flex items-center gap-4 py-1.5 border-b border-gray-100 last:border-b-0">
                <div className={`w-10 h-10 rounded-xl ${stat.color} flex items-center justify-center shrink-0`}>
                  <stat.icon className="w-5 h-5" />
                </div>
                <div>
                  <span className="font-serif font-bold text-[#1a1715] text-[18px] leading-tight block">{stat.value}</span>
                  <span className="text-[11.5px] text-[#8A7E79] font-medium">{stat.label}</span>
                </div>
              </div>
            ))}
          </div>

        </div>

        {/* ── 3. Search & Category Filters Toolbar (Commented Out) ──
        <div className="bg-white rounded-2xl p-4 sm:p-5 border border-[#ECE5E0] shadow-xs space-y-4">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-4">
            
            <div className="relative w-full lg:w-72">
              <input 
                type="text" 
                placeholder="Search institutions..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full bg-[#FAF7F2] border border-[#ECE5E0] rounded-xl pl-4 pr-10 py-2 text-xs focus:outline-none focus:border-[#7B1E3A] transition-colors"
              />
              <LuSearch className="w-4 h-4 text-[#8A7E79] absolute right-3.5 top-1/2 -translate-y-1/2" />
            </div>

            <div className="flex flex-wrap items-center gap-1.5 w-full lg:w-auto">
              {categories.map((cat, idx) => (
                <button
                  key={idx}
                  onClick={() => setSelectedCategory(cat)}
                  className={`text-xs font-semibold px-3.5 py-1.5 rounded-full transition-all cursor-pointer ${
                    selectedCategory === cat 
                      ? 'bg-[#7B1E3A] text-white shadow-xs' 
                      : 'bg-[#FAF7F2] hover:bg-[#F2ECE6] text-[#5F5A58] border border-[#ECE5E0]'
                  }`}
                >
                  {cat}
                </button>
              ))}
            </div>
          </div>

          <div className="flex flex-wrap items-center justify-between gap-4 pt-3 border-t border-gray-100">
            <div className="flex flex-wrap items-center gap-3 w-full sm:w-auto">
              <select 
                value={selectedLocation}
                onChange={(e) => setSelectedLocation(e.target.value)}
                className="bg-[#FAF7F2] border border-[#ECE5E0] rounded-xl px-3 py-1.5 text-xs text-[#5F5A58] focus:outline-none focus:border-[#7B1E3A] cursor-pointer"
              >
                <option value="All Locations">All Locations</option>
                <option value="Kozhikode">Kozhikode</option>
                <option value="Malappuram">Malappuram</option>
                <option value="Kannur">Kannur</option>
                <option value="Wayanad">Wayanad</option>
                <option value="Palakkad">Palakkad</option>
              </select>

              <select 
                value={selectedDistrict}
                onChange={(e) => setSelectedDistrict(e.target.value)}
                className="bg-[#FAF7F2] border border-[#ECE5E0] rounded-xl px-3 py-1.5 text-xs text-[#5F5A58] focus:outline-none focus:border-[#7B1E3A] cursor-pointer"
              >
                <option value="All Districts">All Districts</option>
                <option value="Calicut District">Calicut District</option>
                <option value="Malappuram District">Malappuram District</option>
                <option value="Kannur District">Kannur District</option>
                <option value="Wayanad District">Wayanad District</option>
                <option value="Palakkad District">Palakkad District</option>
              </select>
            </div>

            <div className="flex items-center gap-4 w-full sm:w-auto justify-between sm:justify-end">
              <div className="flex items-center gap-1 bg-[#FAF7F2] p-1 rounded-xl border border-[#ECE5E0]">
                <button 
                  onClick={() => setViewMode('grid')}
                  className={`p-1.5 rounded-lg transition-colors cursor-pointer ${viewMode === 'grid' ? 'bg-white shadow-xs text-[#7B1E3A]' : 'text-[#8A7E79]'}`}
                >
                  <LuLayoutGrid className="w-3.5 h-3.5" />
                </button>
                <button 
                  onClick={() => setViewMode('list')}
                  className={`p-1.5 rounded-lg transition-colors cursor-pointer ${viewMode === 'list' ? 'bg-white shadow-xs text-[#7B1E3A]' : 'text-[#8A7E79]'}`}
                >
                  <LuList className="w-3.5 h-3.5" />
                </button>
              </div>

              <div className="flex items-center gap-2 text-xs text-[#5F5A58]">
                <span>Sort By:</span>
                <select 
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                  className="bg-[#FAF7F2] border border-[#ECE5E0] rounded-xl px-3 py-1.5 text-xs text-[#5F5A58] focus:outline-none focus:border-[#7B1E3A] cursor-pointer"
                >
                  <option value="Newest">Newest</option>
                  <option value="Oldest">Oldest</option>
                  <option value="Name A-Z">Name A-Z</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        ── */}

        {/* ── 4. Featured Institutions Cards Row ── */}
        <div>
          <div className="flex justify-between items-center mb-6">
            <h2 className="font-serif font-bold text-[#7B1E3A] text-[24px] sm:text-[26px]">
              Featured Institutions
            </h2>
            <button 
              onClick={() => onSelectSection('institutions')}
              className="text-[#7B1E3A] hover:text-[#5a1429] text-[12.5px] font-semibold flex items-center gap-1 transition-colors group cursor-pointer"
            >
              <span>View All Institutions</span>
              <span className="text-[13px] group-hover:translate-x-1 transition-transform">→</span>
            </button>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {featuredInstitutions.map((item) => (
              <div 
                key={item.id}
                className="bg-white rounded-2xl overflow-hidden border border-[#ECE5E0] shadow-xs flex flex-col justify-between hover:shadow-md transition-all group"
              >
                {/* Image Container with Badge */}
                <div className="relative h-28 w-full overflow-hidden bg-gray-100">
                  <img 
                    src={item.img} 
                    alt="" 
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = "https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?auto=format&fit=crop&q=80&w=600";
                    }}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  {/* Overlapping Emblem Crest */}
                  <div className="absolute -bottom-3.5 left-1/2 -translate-x-1/2 w-8 h-8 rounded-full bg-white border border-[#ECE5E0] flex items-center justify-center shadow-xs">
                    <LuShield className="w-4 h-4 text-[#7B1E3A]" />
                  </div>
                </div>

                {/* Card Content */}
                <div className="p-3.5 pt-5 flex flex-col justify-between flex-1 text-center">
                  <div>
                    <span className="inline-block text-[9.5px] font-bold text-[#7B1E3A] bg-[#FAF0F2] px-2 py-0.5 rounded-full mb-1.5 border border-[#F2D5DC]">
                      {item.badgeText}
                    </span>
                    <h3 className="font-serif font-bold text-[#1a1715] text-[13px] leading-tight mb-1 group-hover:text-[#7B1E3A] transition-colors line-clamp-2">
                      {item.name}
                    </h3>
                    <div className="flex items-center justify-center gap-1 text-[10.5px] text-[#8A7E79] mb-2">
                      <LuMapPin className="w-3 h-3 text-[#7B1E3A]" />
                      <span>{item.location}</span>
                    </div>
                    <p className="text-[11px] text-[#6A5F5A] leading-snug line-clamp-2 mb-3">
                      {item.desc}
                    </p>
                  </div>

                  <div>
                    <div className="text-[10px] text-[#8A7E79] border-t border-gray-100 pt-2 mb-2.5">
                      <span className="font-medium text-[#1a1715] block">{item.role}: {item.leader}</span>
                      <span className="text-[9px] text-[#8A7E79]">{item.est}</span>
                    </div>

                    <div className="grid grid-cols-2 gap-1.5">
                      <button 
                        onClick={() => onSelectSection(item.route)}
                        className="w-full bg-[#FAF7F2] hover:bg-[#F2ECE6] text-[#5F5A58] text-[10px] font-semibold py-1.5 rounded-lg border border-[#ECE5E0] transition-colors cursor-pointer"
                      >
                        View Details
                      </button>
                      <button 
                        onClick={() => onSelectSection(item.route)}
                        className="w-full bg-[#7B1E3A] hover:bg-[#62162d] text-white text-[10px] font-semibold py-1.5 rounded-lg transition-colors cursor-pointer"
                      >
                        Visit Website
                      </button>
                    </div>
                  </div>
                </div>

              </div>
            ))}
          </div>
        </div>

        {/* ── 5. Our Institutions by Category (8 Bento Cards) ── */}
        <div>
          <h2 className="font-serif font-bold text-[#7B1E3A] text-[24px] sm:text-[26px] mb-6">
            Our Institutions by Category
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {categoryCards.map((cat, idx) => {
              const IconComponent = cat.icon;
              return (
                <div
                  key={idx}
                  onClick={() => onSelectSection(cat.route)}
                  className="group relative rounded-[22px] overflow-hidden shadow-xs hover:shadow-xl transition-all duration-500 cursor-pointer h-52 flex flex-col justify-between p-5 border border-white/10"
                >
                  {/* Background Image */}
                  <img
                    src={cat.img}
                    alt=""
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = "https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?auto=format&fit=crop&q=80&w=600";
                    }}
                    className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 brightness-[0.6] contrast-[1.05]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-transparent"></div>

                  {/* Top Icon and Badge */}
                  <div className="relative z-10 flex items-center justify-between">
                    <div className="w-10 h-10 rounded-xl bg-white/20 backdrop-blur-md flex items-center justify-center text-white border border-white/30 group-hover:bg-[#7B1E3A] transition-colors">
                      <IconComponent className="w-5 h-5" />
                    </div>
                  </div>

                  {/* Bottom Text Content */}
                  <div className="relative z-10 text-left">
                    <h3 className="font-serif font-bold text-white text-lg leading-tight mb-0.5">
                      {cat.title}
                    </h3>
                    <span className="text-[11px] text-[#E8B86D] font-medium block mb-1.5">
                      {cat.count}
                    </span>
                    <p className="text-[11.5px] text-white/85 mb-3 line-clamp-1">
                      {cat.desc}
                    </p>
                    <span className="bg-white/20 hover:bg-white hover:text-[#7B1E3A] text-white text-[10.5px] font-bold py-1 px-3 rounded-full inline-block backdrop-blur-xs transition-colors">
                      View All →
                    </span>
                  </div>
                </div>
              );
            })}

            {/* Need Help? Card (8th Card) */}
            <div className="bg-[#FAF5EF] rounded-[22px] p-5 sm:p-6 border border-[#F2E7DB] shadow-xs flex flex-col justify-between relative overflow-hidden h-52">
              <div className="relative z-10">
                <h3 className="font-serif font-bold text-[#7B1E3A] text-[20px] mb-1.5">
                  Need Help?
                </h3>
                <p className="text-xs text-[#5A4F4A] leading-relaxed mb-4">
                  Can't find what you are looking for? We are here to help you.
                </p>
              </div>

              <button 
                onClick={() => onSelectSection('contact')}
                className="relative z-10 w-max bg-[#7B1E3A] hover:bg-[#62162d] text-white text-xs font-semibold py-2.5 px-5 rounded-full shadow-xs transition-colors flex items-center gap-1.5 cursor-pointer"
              >
                <span>Contact Us</span>
                <LuPhone className="w-3.5 h-3.5" />
              </button>

              {/* Watermark Cross */}
              <div className="absolute -right-4 -bottom-4 opacity-10 pointer-events-none">
                <FaCross className="w-28 h-28 text-[#7B1E3A]" />
              </div>
            </div>
          </div>
        </div>

        {/* ── 6. Bottom Map & Upcoming Events Section ── */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-stretch pt-4">
          
          {/* Left: Institution Map (Col 7) */}
          <div className="lg:col-span-7 bg-white rounded-[24px] p-6 shadow-[0_4px_25px_rgba(0,0,0,0.03)] border border-[#ECE5E0] flex flex-col md:flex-row gap-6">
            <div className="w-full md:w-5/12 flex flex-col justify-between">
              <div>
                <h3 className="font-serif font-bold text-[18px] text-[#7B1E3A] mb-1">
                  Institution Map
                </h3>
                <p className="text-[11px] text-[#8A7E79] mb-4">
                  Find our institutions across Kerala
                </p>

                <div className="space-y-2 text-xs text-[#5A4F4A]">
                  {[
                    { label: "Schools", color: "bg-[#3B82F6]" },
                    { label: "Colleges", color: "bg-[#10B981]" },
                    { label: "Hospitals", color: "bg-[#EF4444]" },
                    { label: "Retreat Centres", color: "bg-[#F59E0B]" },
                    { label: "Book Shop", color: "bg-[#F97316]" },
                    { label: "Social Services", color: "bg-[#8B5CF6]" }
                  ].map((legend, idx) => (
                    <div key={idx} className="flex items-center gap-2.5 p-1 rounded-lg hover:bg-[#FAF7F2] cursor-pointer">
                      <span className={`w-2.5 h-2.5 rounded-full ${legend.color}`}></span>
                      <span className="font-medium text-[#1a1715] text-[11.5px]">{legend.label}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Map Canvas Graphic */}
            <div className="w-full md:w-7/12 h-[260px] md:h-auto min-h-[260px] bg-[#EBF2E8] rounded-2xl relative overflow-hidden border border-[#D5E2D0] flex items-center justify-center">
              <div className="absolute inset-0 opacity-50 bg-[radial-gradient(#b2c9a6_2px,transparent_2px)] [background-size:16px_16px]"></div>
              
              {/* Simulated Kerala Coast Outline / Water backdrop */}
              <div className="absolute -left-10 top-0 bottom-0 w-24 bg-[#DCE7E1] -rotate-12 transform pointer-events-none opacity-80"></div>
              
              {/* Pinned Locations */}
              <div className="absolute top-[28%] left-[35%] w-7 h-7 rounded-full bg-[#3B82F6] text-white flex items-center justify-center text-[10px] font-bold ring-4 ring-white shadow-md cursor-pointer hover:scale-125 transition-transform" title="Calicut Schools">
                72
              </div>
              <div className="absolute top-[48%] left-[50%] w-7 h-7 rounded-full bg-[#10B981] text-white flex items-center justify-center text-[10px] font-bold ring-4 ring-white shadow-md cursor-pointer hover:scale-125 transition-transform" title="Colleges">
                4
              </div>
              <div className="absolute top-[68%] left-[58%] w-7 h-7 rounded-full bg-[#EF4444] text-white flex items-center justify-center text-[10px] font-bold ring-4 ring-white shadow-md cursor-pointer hover:scale-125 transition-transform" title="Hospitals">
                4
              </div>
              <div className="absolute top-[38%] left-[62%] w-6 h-6 rounded-full bg-[#F59E0B] text-white flex items-center justify-center text-[9px] font-bold ring-2 ring-white shadow-md cursor-pointer hover:scale-125 transition-transform" title="Retreats">
                2
              </div>

              {/* Map Zoom Controls */}
              <div className="absolute right-3 bottom-3 flex flex-col bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden">
                <button className="w-7 h-7 flex items-center justify-center hover:bg-gray-50 text-[#1a1715] border-b border-gray-100 text-sm cursor-pointer">
                  <LuPlus className="w-3.5 h-3.5" />
                </button>
                <button className="w-7 h-7 flex items-center justify-center hover:bg-gray-50 text-[#1a1715] text-sm cursor-pointer">
                  <LuMinus className="w-3.5 h-3.5" />
                </button>
              </div>
            </div>
          </div>

          {/* Right: Upcoming Events in Institutions (Col 5) */}
          <div className="lg:col-span-5 bg-white rounded-[24px] p-6 shadow-[0_4px_25px_rgba(0,0,0,0.03)] border border-[#ECE5E0] flex flex-col justify-between relative overflow-hidden">
            <div>
              <div className="flex items-center justify-between mb-4">
                <h3 className="font-serif font-bold text-[18px] text-[#7B1E3A]">
                  Upcoming Events in Institutions
                </h3>
                <button 
                  onClick={() => onSelectSection('events')}
                  className="text-[#7B1E3A] hover:text-[#5a1429] text-xs font-semibold cursor-pointer"
                >
                  View All →
                </button>
              </div>

              <div className="space-y-3.5">
                {[
                  { day: "01", month: "APR", title: "Annual Day Celebration", venue: "CMS College Kottayam", time: "10:00 AM" },
                  { day: "05", month: "JUN", title: "Free Medical Camp", venue: "CSI Mission Hospital, Calicut", time: "09:00 AM" },
                  { day: "12", month: "AUG", title: "Youth Retreat Program", venue: "Santi Bhavan Retreat Centre", time: "10:00 AM" }
                ].map((ev, idx) => (
                  <div key={idx} className="flex items-center gap-3.5 p-2 rounded-xl hover:bg-[#FAF6F2] transition-colors cursor-pointer">
                    <div className="w-12 h-12 rounded-xl border border-[#F2D5DC] bg-white flex flex-col items-center justify-center shrink-0">
                      <span className="font-sans font-extrabold text-[#7B1E3A] text-sm leading-none">{ev.day}</span>
                      <span className="font-sans font-bold text-[#7B1E3A]/70 text-[8px] uppercase">{ev.month}</span>
                    </div>
                    <div className="flex-1 min-w-0">
                      <h4 className="font-serif font-bold text-[#1a1715] text-[13px] leading-tight line-clamp-1">{ev.title}</h4>
                      <span className="text-[11px] text-[#8A7E79] block mt-0.5">{ev.venue}</span>
                    </div>
                    <span className="text-[11px] font-semibold text-[#1a1715] shrink-0">{ev.time}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="mt-5 flex items-center justify-between">
              <button 
                onClick={() => onSelectSection('events')}
                className="bg-[#7B1E3A] hover:bg-[#62162d] text-white text-xs font-semibold py-2.5 px-5 rounded-full shadow-xs transition-colors cursor-pointer"
              >
                View All Events ▾
              </button>

              {/* Watermark Crest */}
              <div className="opacity-15 pointer-events-none">
                <GiCrossedChains className="w-12 h-12 text-[#7B1E3A]" />
              </div>
            </div>
          </div>

        </div>

      </div>

    </div>
  );
}
